import * as React from 'react';
import { AccountActions } from './Actions.js';
import { Container, StyledHint, Delimiter } from './styles.js';
import { TopSection } from './TopSection.js';

const AccountMenu = ({ actionsProps , unreadMessages , userName , accountEmail , isAccountVerified , isAccountIncomplete , profileButtonText , hasTopSection =true , hintText  })=>{
    return /*#__PURE__*/ React.createElement(Container, null, hasTopSection && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TopSection, {
        actionProps: actionsProps.YourProfile,
        userName: userName,
        accountEmail: accountEmail,
        isAccountVerified: isAccountVerified,
        isAccountIncomplete: isAccountIncomplete,
        profileButtonText: profileButtonText
    }), hintText && /*#__PURE__*/ React.createElement(StyledHint, {
        text: hintText
    }), /*#__PURE__*/ React.createElement(Delimiter, null)), /*#__PURE__*/ React.createElement(AccountActions, {
        actionsProps: actionsProps,
        unreadMessages: unreadMessages
    }));
};

export { AccountMenu };
